import { UseFieldArrayRemove } from 'react-hook-form/dist/types/fieldArray'
import { Path, useFormContext } from 'react-hook-form'
import { SocioeducationMeasureMeasuresAppliedType } from 'types/socioeducation-measure-measures-applied.type'
import { Grid, IconButton, Paper } from '@mui/material'
import FormInputDatePicker from 'components/FormInputDatePicker'
import { FormInputFile } from 'components/FormInputFile'
import DeleteIcon from '@mui/icons-material/Delete'
import React from 'react'
import { extractFileExtension } from 'utils/document.util'

interface MeasuresAppliedItemProps {
  index: number
  remove: UseFieldArrayRemove
  disabled?: boolean
}

export const MeasuresAppliedItem = ({ index, remove, disabled }: MeasuresAppliedItemProps) => {
  const { control, watch, setValue, setError, clearErrors } =
    useFormContext<SocioeducationMeasureMeasuresAppliedType>()

  const isLa = watch('la.ativo')
  const isPsc = watch('psc.ativo')

  const pscDataInicioCumprimentoField =
    `medidasAplicadas.${index}.psc.dataInicioCumprimento` as Path<SocioeducationMeasureMeasuresAppliedType>
  const laDataInicioCumprimentoField =
    `medidasAplicadas.${index}.la.dataInicioCumprimento` as Path<SocioeducationMeasureMeasuresAppliedType>
  const dataEntregaRelatorioField =
    `medidasAplicadas.${index}.dataEntregaRelatorio` as Path<SocioeducationMeasureMeasuresAppliedType>
  const anexoArquivoBase64Field =
    `medidasAplicadas.${index}.anexo.arquivoBase64` as Path<SocioeducationMeasureMeasuresAppliedType>
  const anexoArquivoTipoField =
    `medidasAplicadas.${index}.anexo.arquivoTipo` as Path<SocioeducationMeasureMeasuresAppliedType>
  const anexoArquivoNomeField =
    `medidasAplicadas.${index}.anexo.arquivoNome` as Path<SocioeducationMeasureMeasuresAppliedType>

  return (
    <Paper
      variant='outlined'
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 2,
        p: 2,
        width: '100%',
        backgroundColor: 'white',
      }}
    >
      <Grid container item spacing={2}>
        {isLa && (
          <Grid item lg={3} md={4} xs={12}>
            <FormInputDatePicker
              label={'Data Início do Cumprimento da LA'}
              name={laDataInicioCumprimentoField}
              enableFuture={true}
              control={control}
              disabled={disabled}
            />
          </Grid>
        )}
        {isPsc && (
          <Grid item lg={3} md={4} xs={12}>
            <FormInputDatePicker
              label={'Data Início do Cumprimento da PSC'}
              name={pscDataInicioCumprimentoField}
              enableFuture={true}
              control={control}
              disabled={disabled}
            />
          </Grid>
        )}
        <Grid item lg={3} md={4} xs={12}>
          <FormInputDatePicker
            label={'Data de Entrega do Relatório'}
            name={dataEntregaRelatorioField}
            enableFuture={true}
            control={control}
            disabled={disabled}
          />
        </Grid>
        <Grid item lg={3} md={3} xs={12}>
          <FormInputFile
            control={control}
            name={anexoArquivoBase64Field}
            nameFilename={anexoArquivoTipoField}
            nameFiletype={anexoArquivoNomeField}
            setValue={setValue}
            setError={setError}
            clearErrors={clearErrors}
            disabled={disabled}
            onValidDocumentFile={(file) => {
              const acceptedFormats = ['pdf']
              const maxFileSizeInBytes = 10 * 1024 * 1024 // 10MB

              const fileExtension = extractFileExtension(file.name)
              if (!fileExtension || !acceptedFormats.includes(fileExtension.toLocaleLowerCase())) {
                return false
              }

              return file.size <= maxFileSizeInBytes
            }}
          />
        </Grid>
      </Grid>
      <IconButton color={'error'} onClick={() => remove(index)} disabled={disabled}>
        <DeleteIcon />
      </IconButton>
    </Paper>
  )
}
